import { Appearance, DraftConfiguration } from '@/types';
import { getAvailablePrintTypes } from './getAvailablePrintTypes';

export const getCommonPrintTypes = (
  configurations: DraftConfiguration[],
  appearance: Appearance
) => {
  if (configurations.length === 0) {
    return [];
  }

  const [firstConfiguration, ...otherConfigurations] = configurations;
  const availablePrintTypes = getAvailablePrintTypes(firstConfiguration, appearance);

  if (otherConfigurations.length === 0) {
    return availablePrintTypes;
  }

  const commonPrintTypeIds = new Set(availablePrintTypes.map(({ id }) => id));
  otherConfigurations.forEach((configuration) => {
    const availablePrintTypeIds = new Set(
      getAvailablePrintTypes(configuration, appearance).map(({ id }) => id)
    );
    commonPrintTypeIds.forEach((printTypeId) => {
      if (!availablePrintTypeIds.has(printTypeId)) {
        commonPrintTypeIds.delete(printTypeId);
      }
    });
  });

  return availablePrintTypes.filter(({ id }) => commonPrintTypeIds.has(id));
};
